import { Component } from 'react'
import PropTypes from 'prop-types'
import { debounceAsync } from '../async'

export default class Query extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data: null,
      error: null,
    }

    this.fetchId = 0
    this.query = debounceAsync(() => this.props.query(), 500)
  }

  componentDidMount() {
    this.executeQuery()
  }

  componentDidUpdate({ query: oldQuery }) {
    if (oldQuery !== this.props.query) {
      this.executeQuery()
    }
  }

  render() {
    return this.props.children({
      loading: this.state.loading,
      data: this.state.data,
      error: this.state.error,
      refetch: this.executeQuery.bind(this),
    })
  }

  executeQuery() {
    const currentFetchId = ++this.fetchId

    this.setState(state => ({
      loading: true,
      data: this.props.emptyWhileLoading !== false ? null : state.data,
      error: null,
    }))
    try {
      this.query()
        .then(data => {
          if (currentFetchId === this.fetchId) {
            this.setState({ loading: false, data: data })
          }
        })
        .catch(error => {
          if (currentFetchId === this.fetchId) {
            this.setState({ loading: false, error: error })
          }
        })
    } catch (e) {
      this.setState({ loading: false, error: e })
    }
  }
}

Query.propTypes = {
  children: PropTypes.func,
  query: PropTypes.func,
  emptyWhileLoading: PropTypes.bool,
}
